<script>
export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <v-tooltip open-delay="0" close-delay="0" right>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" :color="options.color || 'primary'" small>{{
        options.icon
      }}</v-icon>
    </template>

    <span>{{ options.description }}</span>
  </v-tooltip>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Status/IconTooltip.vue